// The list and the report under edit both read a report's status, so the status
// lives on the plural side. The singular library re-exports it, which is the
// direction ADR-0023 allows.
export const ReportStatuses = {
  Draft: 'draft',
  Started: 'started',
  Completed: 'completed',
  Historical: 'historical',
  Deleted: 'deleted',
} as const;
export type ReportStatus = (typeof ReportStatuses)[keyof typeof ReportStatuses];
